<template>
    <IconBase  v-bind="$props" v-on="$listeners">
        <rect x="0.666667" y="0.666667" width="30.6667" height="30.6667" rx="15.3333" fill="white"/>
        <rect x="0.666667" y="0.666667" width="30.6667" height="30.6667" rx="15.3333" stroke="white" stroke-width="1.33333"/>
        <path d="M20.9489 12.4625L17.4133 15.998L20.9489 19.5336C21.1364 19.7211 21.2417 19.9755 21.2417 20.2407C21.2417 20.5059 21.1364 20.7603 20.9489 20.9478C20.7613 21.1353 20.507 21.2407 20.2417 21.2407C19.9765 21.2407 19.7222 21.1353 19.5346 20.9478L15.9991 17.4123L12.4636 20.9478C12.276 21.1353 12.0217 21.2407 11.7565 21.2407C11.4912 21.2407 11.2369 21.1353 11.0494 20.9478C10.8618 20.7603 10.7565 20.5059 10.7565 20.2407C10.7565 19.9755 10.8618 19.7211 11.0494 19.5336L14.5849 15.998L11.0494 12.4625C10.8618 12.275 10.7565 12.0206 10.7565 11.7554C10.7565 11.4902 10.8618 11.2358 11.0494 11.0483C11.2369 10.8608 11.4912 10.7554 11.7565 10.7554C12.0217 10.7554 12.276 10.8608 12.4636 11.0483L15.9991 14.5838L19.5346 11.0483C19.7222 10.8608 19.9765 10.7554 20.2417 10.7554C20.507 10.7554 20.7613 10.8608 20.9489 11.0483C21.1364 11.2358 21.2417 11.4902 21.2417 11.7554C21.2417 12.0206 21.1364 12.275 20.9489 12.4625Z" fill="black"/>
    </IconBase>
</template>


<script>
import IconBase from './iconBase/IconBase.vue'
import iconProps from './iconBase/iconProps.js'

export default {
  components: { IconBase },
  props: {
    ...iconProps,
    height: {
        ...iconProps.height,
        default: 32,
    },
    width: {
        ...iconProps.width,
        default: 32,
    },
    viewBox: {
        ...iconProps.viewBox,
        default: "0 0 32 32",
    }
  },
}
</script>